/**
 * @flow
 */

import { Auth, Logger } from "aws-amplify"
import { navigate } from "gatsby"
import React, { useMemo } from "react"
import { useDispatch } from "react-redux"
import styled from "styled-components"

import { notify } from "../../../state"
import Form from "./form"
import media from "../../../styles/media"
import PageHeader from "../../elements/PageHeader"

import info from "../../../images/Auth/info-icon.svg"

type Props = {
  location: Object,
}

const Container = styled.div`
  &.red {
    background-color: rgba(196, 18, 48, 0.99);
  }
  &.black {
    background-color: rgba(63, 63, 63, 0.99);
  }
  &.p-left {
    padding-left: var(--gutter-s);
  }
  &.p-left-l {
    padding-left: var(--gutter-l);
  }
  &.p-right {
    padding-right: var(--gutter-s);
  }
  &.p-top,
  &.p-bottom {
    padding-bottom: 10vh;
  }
  ${media.tablet`
    &.p-left {
      padding-left: 10vw;
    }
    &.p-left-l {
      padding-left: 10vw;
    }
    &.p-right {
      padding-right: 5vw;
    }
    &.p-top,
    &.p-bottom {
      padding-bottom: 15vh;
    }
  `}
  ${media.laptop`
    &.p-left {
      padding-left: 25vw;
    }
    &.p-left-l {
      padding-left: 25vw;
    }
    &.p-right {
      padding-right: 20vw;
    }
  `}
`

const Intro = styled.div`
  margin-bottom: 2rem;
  position: relative;
  padding-top: 60px;
  h1,
  p {
    color: rgba(255, 255, 255, 0.8);
  }
  h1 {
    font-family: "AvenirLTStdBlack";
    font-size: 3rem;
    margin-bottom: 1rem;
    text-transform: uppercase;
    display: inline-block;
    line-height: 1;
    position: absolute;
    left: 0;
    top: 0;
    transform: translateY(-50%) rotate(-2deg);
  }
  p {
    font-family: "butlermedium";
    line-height: 1.75rem;
    a {
      text-decoration: underline;
    }
  }
  ${media.laptop`
    padding-top: 80px;
    h1 {
      font-size: 8rem;
    }
  `}
`

const Protection = styled.div`
  display: flex;
  align-items: center;
  padding-top: 4rem;
  img {
    height: 20px;
    width: auto;
    margin-right: 20px;
  }
  p {
    font-family: "AvenirLTStdMedium";
    font-size: 0.8rem;
    line-height: 1rem;
  }
`

const ResetPasswordPage = ({ location }: Props) => {
  const logger = useMemo(() => new Logger(ResetPasswordPage.name), [])
  const dispatch = useDispatch()

  const handleFormSubmit = async (values, actions) => {
    const { code, password } = values
    const { email } = location.state
    try {
      await Auth.forgotPasswordSubmit(email, code, password)
      dispatch(
        notify({
          message: "Your password was reset successfully! You may now sign in.",
          variant: "success",
        })
      )
      navigate("/sign-in", { replace: true })
    } catch (err) {
      logger.error(err)
      dispatch(
        notify({
          message: err.message,
          variant: "error",
        })
      )
    } finally {
      actions.setSubmitting(false)
    }
  }
  return (
    <>
      <Container className="red p-left-l p-bottom">
        <PageHeader />
      </Container>
      <Container className="black p-left p-right p-bottom">
        <Intro>
          <h1>Password</h1>
          <p>Create your new password below</p>
        </Intro>
        <Form onSubmit={handleFormSubmit} />
        <Protection>
          <img src={info} alt="Sound Idea Sessions | Sign In" />
          <p>Your information is protected</p>
        </Protection>
      </Container>
    </>
  )
}

export default ResetPasswordPage
